import React, { useContext } from 'react';
import UserSettingsContext from '../../context/UserSettingsContext';
import styled from 'styled-components';

const ToggleWrap = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 4.625rem;
  right: 1.5rem;

  @media (min-width: 768px) {
    top: .5rem;
  }
`;

const ToogleLabel = styled.div`
  margin-right: .5rem;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
`;

const Toggle = styled.div`
  width: 4.5rem;
  height: 1.5rem;
  background-color: #d8dee9;
  cursor: pointer;
  user-select: none;
  border-radius: 0.125rem;
  position: relative;
`;

const ToggleButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 46px;
  position: absolute;
  left: -2px;
  top: -1px;
  padding: 0.0625rem 0;
  color: white;
  font-weight: 700;
  background-color: #a3be8c;
  cursor: pointer;
  border-radius: 0.125rem;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;

  &.lb {
    left: 28px;
    background-color: #b48ead;
  }
`;

const ToggleSwitch = () => {
  const { units, setUnits } = useContext(UserSettingsContext);

  const toggleUnit = () => {
    const unit = units === 'kg' ? 'lb' : "kg";
    setUnits(unit);
  }

  return (
    <ToggleWrap>
      <ToogleLabel>Units</ToogleLabel>

      <Toggle onClick={toggleUnit}>
        <ToggleButton className={`${units === 'kg' ? "" : "lb"}`}>
          {units === 'kg' ? "KG" : "LB"}
        </ToggleButton>
      </Toggle>
    </ToggleWrap>
  );
};

export default ToggleSwitch;
